import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GridMetrics, GroupBounds } from 'Vendor/Utils/StudioTypes';

interface GridState {
    groupBounds: GroupBounds | null;
    gridMetrics: GridMetrics | null;
}

const initialState: GridState = {
    groupBounds: null,
    gridMetrics: null,
};

const gridSlice = createSlice({
    name: 'studioGrid',
    initialState,
    reducers: {
        setGroupBounds(state, action: PayloadAction<GridState['groupBounds']>) {
            state.groupBounds = action.payload;
        },
        setGridMetrics(state, action: PayloadAction<GridState['gridMetrics']>) {
            state.gridMetrics = action.payload;
        },
    },
});

export const { setGroupBounds, setGridMetrics } = gridSlice.actions;
export default gridSlice.reducer;
